import { SessionStorageType, UnsavedChangesStoresKey } from 'src/domain';
import { useUnsavedChanges } from './useUnsavedChanges';

export const useUnsavedStores = <T = unknown>() => {
    return useUnsavedChanges<SessionStorageType<T>>(UnsavedChangesStoresKey);
};
